import angular from 'angular';
import template from './entitiesAutocomplete.html';
import './entitiesAutocomplete.scss';

export class EntitiesAutocompleteController {
  constructor($document, $timeout, KEY_CODES) {
    'ngInject';

    [this.$document] = Array.from($document);
    this.$timeout = $timeout;
    this.KEY_CODES = KEY_CODES;
    this.autocompleteText = '';
    this.currentIndex = -1;

    this.hasFocus = false;

    this._minLength = 3;
    this._cleanOnSelect = true;
    this._hasElements = false;
    this._elements = {
      scroller: null,
      list: null,
      results: null,
    };

    this._selectors = {
      scroller: '',
      list: '',
      results: '',
    };

    this._currentScrollPosition = 0;
  }
  $onInit() {
    if (angular.isUndefined(this.autoFocusOnEnabled)) {
      this.autoFocusOnEnabled = true;
    }

    this._selectors.scroller = `[data-entities-autocomple-scroller="${this.id}"]`;
    this._selectors.list = `${this._selectors.scroller} [data-entities-autocomple-list]`;
    this._selectors.results = `${this._selectors.scroller} [data-entities-autocomple-result]`;
  }
  $onChanges({ minLength, cleanOnSelect }) {
    if (minLength && minLength.currentValue) {
      this._minLength = parseInt(minLength.currentValue, 10);
    }

    if (cleanOnSelect && angular.isDefined(cleanOnSelect.currentValue)) {
      this._cleanOnSelect = cleanOnSelect.currentValue === 'true';
    }
  }
  search() {
    if (this.autocompleteText.length >= this._minLength) {
      this._hasElements = false;
      this.currentIndex = -1;
      this.onSearch({ text: this.autocompleteText });
    }
  }
  move($event) {
    if (this.results.length) {
      const { keyCode } = $event;
      if (keyCode === this.KEY_CODES.arrows.down) {
        $event.preventDefault();
        this._moveDown();
      } else if (keyCode === this.KEY_CODES.arrows.up) {
        $event.preventDefault();
        this._moveUp();
      }
    }
  }
  submit($event) {
    if ($event.keyCode === this.KEY_CODES.enter) {
      $event.preventDefault();
      if (this.results.length && this.currentIndex > -1) {
        this._notifySelected();
      }
    }
  }
  focus() {
    this.hasFocus = true;
    if (this.results.length) {
      this.$timeout(() => {
        this._getElements().scroller.scrollTop = this._currentScrollPosition;
      });
    }
  }
  dismiss() {
    if (this.results.length) {
      this._currentScrollPosition = this._getElements().scroller.scrollTop;
    }

    this.hasFocus = false;
    this._hasElements = false;
  }
  select($index) {
    this.currentIndex = $index;
    this._notifySelected();
  }
  _moveDown() {
    const nextIndex = this.currentIndex + 1;
    if (nextIndex < this.results.length) {
      this.currentIndex = nextIndex;
      this._moveToCurrentIndex();
    }
  }
  _moveUp() {
    const nextIndex = this.currentIndex - 1;
    if (nextIndex > -1) {
      this.currentIndex = nextIndex;
      this._moveToCurrentIndex();
    }
  }
  _notifySelected() {
    this.onSelect({ entity: this.results[this.currentIndex] });
    if (this._cleanOnSelect) {
      this.autocompleteText = '';
    }
  }
  _getElements() {
    if (!this._hasElements) {
      this._elements.scroller = this.$document.querySelector(this._selectors.scroller);
      this._elements.list = this.$document.querySelector(this._selectors.list);
      this._elements.results = [...this.$document.querySelectorAll(this._selectors.results)];
      this._hasElements = true;
    }

    return this._elements;
  }
  _moveToCurrentIndex() {
    const { scroller, list, results } = this._getElements();
    const scrollerHeight = scroller.offsetHeight;
    if (list.offsetHeight > scrollerHeight) {
      const result = results[this.currentIndex];
      const top = scroller.scrollTop;
      const bottom = top + scrollerHeight;
      const elementHeight = result.offsetHeight;
      const elementTop = result.offsetTop;
      const elementBottom = elementTop + elementHeight;
      if (elementTop < top) {
        scroller.scrollTop = elementTop;
      } else if (elementBottom > bottom) {
        scroller.scrollTop = elementBottom - scrollerHeight;
      }
    }
  }
}

export default {
  controller: EntitiesAutocompleteController,
  template,
  bindings: {
    id: '@',
    cleanOnSelect: '@',
    minLength: '@',
    onSearch: '&',
    onSelect: '&',
    debounce: '@',
    results: '<',
    disableAutocomplete: '<',
  },
};
